<template>
  <div>
    <v-row no-gutters v-if="!loading && dataSet">
      <v-col cols="12" md="8" class="pa-2 mb-5" style="display: grid">
        <v-card flat class="rounded-lg" style="overflow: hidden">
          <div style="width: 100%">
            <div>
              <img :src="cover" width="100%" height="300px" alt="" />
              <div
                class="d-flex justify-space-between pa-3"
                style="position: absolute; top: 0; z-index: 2; width: 100%"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="white"
                      v-bind="attrs"
                      v-on="on"
                      @click="$router.go(-1)"
                      icon
                      ><v-icon color="black">mdi-reply</v-icon></v-btn
                    >
                  </template>
                  <span>Back</span>
                </v-tooltip>
                <v-tooltip
                  top
                  v-if="
                    $route.params.idTSA == profile.university_id &&
                    permissions.includes('TSA')
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="white"
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        $router.push(
                          `/admin/tsa/update/tsa/${$route.params.idTSA}`,
                        )
                      "
                      icon
                      ><v-icon color="black">mdi-pencil</v-icon></v-btn
                    >
                  </template>
                  <span>Update</span>
                </v-tooltip>
              </div>
            </div>
            <div class="pa-5">
              <img
                v-if="!dataSet.profile_picture"
                src="../../../../assets/img/university_default.png"
                class="pa-2 rounded-lg obj_fit"
                style="margin-top: -95px; background-color: white"
                height="125px"
                width="125px"
                alt=""
              />
              <img
                v-if="dataSet.profile_picture"
                :src="dataSet.profile_picture"
                class="pa-2 rounded-lg obj_fit"
                style="margin-top: -95px; background-color: white"
                height="125px"
                width="125px"
                alt=""
              />
              <v-row no-gutters>
                <v-col cols="6" class="pa-2">
                  <h3>TSA {{ dataSet.name }}</h3>
                  <h4 style="color: #006341">
                    {{
                      dataSet.city
                        ? dataSet.city
                        : "-" + ", " + dataSet.province
                        ? dataSet.province
                        : "-"
                    }}
                  </h4>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <h4>TSA Organogram</h4>
                  <div class="d-flex align-center">
                    <v-icon>mdi-file-document</v-icon>
                    <a :href="dataSet.structure" target="_blank"
                      >TSA Organogram.pdf</a
                    >
                  </div>
                </v-col>
              </v-row>
              <div class="mt-3" style="width: 300px">
                <!-- <h5 style="color: rgba(0, 0, 0, 0.4)">
                  {{ dataScholar.length }} students enrolled in the Tanoto
                  scholarship
                </h5> -->
                <h5 style="color: #006341" class="text-center">
                  {{ countMale }} male scholars · {{ countFemale }} female
                  scholars
                </h5>
                <div v-if="optGender">
                  <apexchart
                    width="300"
                    type="pie"
                    :options="optGender.options"
                    :series="optGender.series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </v-card>

        <v-card flat color="white" class="mt-5 rounded-lg">
          <div style="width: 100%" class="pa-5">
            <div>
              <h3 style="color: #006341">About TSA</h3>
              <p class="mt-2">
                {{ dataSet.about ? dataSet.about : "Data is Empty" }}
              </p>
            </div>
          </div>
        </v-card>
        <v-card flat color="white" class="mt-5 rounded-lg">
          <div style="width: 100%" class="pa-5">
            <div>
              <h3 style="color: #006341">Contact</h3>
              <v-row no-gutters align="start" class="mt-2">
                <v-col cols="6">
                  <div class="mr-4">
                    <h4>{{ dataSet.name }}</h4>
                    <h5>{{ dataSet.address }}</h5>
                    <h5>Phone: {{ dataSet.phone_number }}</h5>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="ml-4">
                    <h4>Social Media</h4>
                    <v-row no-gutters align="center">
                      <v-col>
                        <v-btn
                          small
                          fab
                          icon
                          :href="dataSet.twitter"
                          target="_blank"
                        >
                          <v-icon color="#006341">mdi-twitter</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          fab
                          icon
                          :href="dataSet.youtube"
                          target="_blank"
                        >
                          <v-icon color="#006341">mdi-youtube</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          fab
                          icon
                          :href="dataSet.instagram"
                          target="_blank"
                        >
                          <v-icon color="#006341">mdi-instagram</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          fab
                          icon
                          :href="dataSet.facebook"
                          target="_blank"
                        >
                          <v-icon color="#006341">mdi-facebook</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          fab
                          icon
                          :href="dataSet.linkedin"
                          target="_blank"
                        >
                          <v-icon color="#006341">mdi-linkedin</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" class="pa-2" style="display: grid">
        <!-- TSA CALENDAR ===================================================================================== -->
        <v-card
          flat
          class="rounded-lg"
          style="overflow: hidden"
          min-height="250px"
          v-if="
            profile.university_id == $route.params.idTSA && profile.permissions
          "
        >
          <tsa-calendar />
        </v-card>

        <v-card
          flat
          class="rounded-lg d-flex align-center pa-3"
          min-height="250px"
          v-else
        >
          <h1 class="grey--text text-center">Calendar Not Available</h1>
        </v-card>
        <v-card
          flat
          color="white"
          class="mt-5 rounded-lg"
          style="overflow: hidden"
        >
          <div style="width: 100%" class="pa-5">
            <v-row no-gutters>
              <v-col cols="12" md="9">
                <h4 style="color: #006341">Activities already done</h4>
              </v-col>
              <v-col cols="12" md="3" class="d-flex justify-end">
                <router-link
                  :to="`/scholar/tsa/detail-tanoto-scholar-academy/list-activity/${this.$route.params.idTSA}`"
                >
                  View All
                </router-link>
              </v-col>
            </v-row>
            <!-- <div class="d-flex align-center" v-for="n in 3" :key="n">
              <div class="circle_dot">
                <h4 style="color: white">{{ n }}</h4>
              </div>
              <div class="ml-3">
                <h5>Internship</h5>
                <h5 style="font-weight: normal; color: rgba(0, 0, 0, 0.4)">
                  Ultrices nisl eget nunc.
                </h5>
              </div>
            </div> -->
          </div>
        </v-card>
        <v-card
          flat
          color="white"
          class="mt-5 rounded-lg"
          style="overflow: hidden"
          height="max-content"
        >
          <div style="width: 100%" class="pa-5">
            <v-row no-gutters>
              <v-col cols="12" md="9">
                <h4 style="color: #006341">Active Scholars</h4>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="d-flex justify-end"
                v-if="dataScholar.length"
              >
                <router-link
                  :to="`/scholar/tsa/detail-tanoto-scholar-academy/list-scholar/${this.$route.params.idTSA}`"
                >
                  View All
                </router-link>
              </v-col>
            </v-row>
            <div v-if="dataScholar">
              <div
                class="mt-2 d-flex align-center"
                v-for="(item, n) in dataScholar"
                :key="n"
              >
                <router-link
                  class="opener_name pa-2"
                  :to="`/scholar/${item.user_id}`"
                >
                  <v-avatar size="50">
                    <v-img
                      :src="item.profile_picture ? item.profile_picture : ava"
                    />
                  </v-avatar>
                </router-link>

                <div class="ml-3">
                  <router-link
                    class="opener_name"
                    :to="`/scholar/${item.user_id}`"
                  >
                    <h5 class="black--text">{{ item.name }}</h5>
                  </router-link>
                  <h5 style="font-weight: normal; color: rgba(0, 0, 0, 0.4)">
                    {{ item.no_tf }}
                  </h5>
                </div>
              </div>
            </div>
            <div
              v-if="!dataScholar.length && !loading"
              class="mt-2 empty d-flex align-center justify-center flex-column"
            >
              <img
                src="../../../../assets/img/redaksi/pagenotfound.png"
                height="150px"
                alt=""
              />
              <b class="default_txt my-3">Data not found</b>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="loading">
      <v-col cols="12" md="8" class="pa-2">
        <v-card flat>
          <div style="width: 100%; height: 40vh">
            <v-skeleton-loader
              type="card, list-item-three-line"
            ></v-skeleton-loader>
          </div>
        </v-card>
        <v-card flat class="mt-5">
          <div style="width: 100%; height: 20vh">
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          </div>
        </v-card>
        <v-card flat class="mt-5">
          <div style="width: 100%; height: 20vh">
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <v-card flat>
          <div style="width: 100%; height: 30vh">
            <v-skeleton-loader type="date-picker"></v-skeleton-loader>
          </div>
        </v-card>
        <v-card flat class="mt-5">
          <div style="width: 100%; height: 20vh">
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          </div>
        </v-card>
        <v-card flat class="mt-5">
          <div style="width: 100%; height: 30vh">
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import tsaCalendar from "./tsaCalendar.vue";
import { mapState } from "vuex";

export default {
  components: { tsaCalendar },
  name: "detailTSAScholar",
  computed: {
    ...mapState({
      ava: (state) => state.ava,
      profile: (state) => state.profile,
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  data() {
    return {
      loading: false,
      dataSet: null,
      dataScholar: null,
      countMale: 0,
      countFemale: 0,
      optGender: null,
      cover: require("../../../../assets/img/gundam/LMS Aset Illustrasi No Course.png"),
    };
  },
  mounted() {
    this.fetchScholar();
    this.fetchScholarGenderMale();
  },
  methods: {
    fetchScholar() {
      this.loading = true;
      let data = {
        path: `manage/scholar?filter[university_id]=${this.$route.params.idTSA}&page[size]=5`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataScholar = data.data;
          this.fetchData();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },

    fetchScholarGenderMale() {
      let data = {
        path: `manage/scholar?filter[gender]=Male&filter[university_id]=${this.$route.params.idTSA}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.countMale = data.data.length;
          this.fetchScholarGenderFemale();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchScholarGenderFemale() {
      let data = {
        path: `manage/scholar?filter[gender]=Female&filter[university_id]=${this.$route.params.idTSA}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.countFemale = data.data.length;

          let series = [this.countFemale, this.countMale];
          let options = {
            chart: {
              id: "vuechart-example",
            },
            colors: ["#99c1b4", "#006341"],
            labels: ["Female", "Male"],
            legend: {
              show: false,
            },
          };
          this.optGender = {
            options: options,
            series: series,
          };
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchData() {
      let data = {
        path: `manage/univ/get?filter[id]=${this.$route.params.idTSA}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data[0];
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.circle_dot {
  background: #006341;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
